import type { ReactNode } from 'react';
import { createElement } from 'react';
import type { StripeProductInfoProps } from '@george-labs.com/design-system/types/components/Stripe/StripeProductInfo';
import { Avatar } from '@george-labs.com/design-system';

import type { Account } from '@shared/products-types';
import type { ProductWithHelpers } from '@shared/products-core';
import { LocalizedAmount, PermittedAmount } from '@shared/core-ui-amount';
import { t } from '@luna/i18n';
import { isFeatureEnabled } from '@luna/gatekeeper';

import { getTitleAlignedWithGeorgeApp } from './titleService';

function createAmountForStripeProductInfo(account: ProductWithHelpers<Account>): ReactNode {
    const usePermittedAmount = isFeatureEnabled(
        (config) => config.payments.usePermittedAmountInStripeProductInfo,
    );

    if (usePermittedAmount) {
        return createElement(PermittedAmount, {
            amount: account.mainAmount,
            flags: account.flags,
        });
    }

    return createElement(LocalizedAmount, {
        amount: account.mainAmount,
    });
}

export function getStripeProductInfo(account: ProductWithHelpers<Account>): StripeProductInfoProps {
    return {
        amount: createAmountForStripeProductInfo(account),
        amountLabel: t('main.menu.v2.products.detail.amountLabel_a11y'),
        avatar: createElement(Avatar, { icon: account.icon, imageUrl: account.imageData }),
        alias: getTitleAlignedWithGeorgeApp(account),
        aliasLabel: t('main.menu.v2.products.detail.aliasLabel_a11y'),
        productNumber: account.formattedAccountNumber,
    };
}
